module.exports = __webpack_public_path__ + "staticcomp/img/about_us_bt.eedcc55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_us_bt.png
// module id = lMC1
// module chunks = 39